<script setup>
import { useUserStore } from "@/stores/user";
import { onBeforeRouteUpdate, useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()

const router = useRouter();
const userStore = useUserStore();
const username = ref();
const useHospital = ref()
let logout = () => {
  userStore.logout();
  sessionStorage.removeItem("isLogin");
  router.push({ name: "login" });
};

username.value = userStore.name;
useHospital.value = userStore.hospital
// console.log("username", username.value);

onMounted(() => {
  // 在组件挂载到 DOM 后执行的代码
  // username.value = userStore.name;
});

const openinnermsg = () => {
  commonStore.innermsg = true
}


onBeforeRouteUpdate((to, from, next) => {
  console.log("onBeforeRouteUpdate", to, from, next);
  next();
});
</script>

<template>
  <nav>
    <el-row>
      <el-col :span="17">
        <div class="logo">中国PSVD患者的临床特征及预后研究</div>
      </el-col>
      <el-col :span="7">
        <div class="action">
          <p @click="openinnermsg" style="margin:0;"><el-icon class="innermsg" ><Bell /></el-icon></p>
          <p class="username_hospital" >
            <p class="username" v-if="username"> <span class="span">您好</span>， <span>{{ username }} </span></p>
            <!-- 用户机构信息 -->
            <p class="hospital" v-if="useHospital">{{ useHospital }}</p>
          </p>
          <el-button class="btn-logout" circle @click="logout" title="退出系统">
            <el-icon>
              <SwitchButton />
            </el-icon>
          </el-button> 
        </div>
      </el-col>
    </el-row>

  </nav>
</template>

<style scoped  lang="scss">
.innermsg{
  font-size: 18px;
  padding: 7px;
  background-color: #ffffff;
  color: #888787;
    border-radius: 50%;

}
nav {
    background-color: #D84357;
    padding: 15px;
}

.logo {
    margin: 0;
    color: #ffffff;
    font-size: 24px;
    line-height: 40px;
}

.action {
    color: #ffffff;
    text-align: right;
    line-height: 40px;
    display: flex;
    justify-content: end; 
}
.username_hospital{
  margin: 0 0 0 30px;
}
.hospital{
  margin: 0;
  color: white;
  font-size: 13px;
  line-height: 25px;
}
.username {
    margin: 0;
    line-height: 30px;
    vertical-align: middle;
    display: flex;
    flex-wrap: wrap;
    justify-content: start; 
    width: 56px;
    .span{
     
      margin: 0;
      padding: 0;
      text-wrap: nowrap;
    }
}
</style>
